import React, { Component } from 'react';
import _ from 'lodash';
import { verifyOtp, resendOtp } from '../utils/paymentApi';
import { setAuthToken } from '../utils/guestStorage';
import { showError, showSuccess } from '../utils/snackbar';
import './Auth.css';

// Email OTP verification after signup
class VerifyEmail extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(window.location.search);
    this.state = {
      email: params.get('email') || '',
      otp: '',
      loading: false,
    };
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  handleVerify = async (event) => {
    event.preventDefault();
    try {
      this.setState({ loading: true });
      const result = await verifyOtp({
        email: this.state.email,
        otp: this.state.otp,
      });
      setAuthToken(_.get(result, 'token', ''));
      window.location.href = '/profile';
    } catch (e) {
      showError(_.get(e, 'message', 'Verification failed'));
    } finally {
      this.setState({ loading: false });
    }
  };

  handleResend = async () => {
    try {
      this.setState({ loading: true });
      await resendOtp(this.state.email);
      showSuccess('A new code was sent if the account exists.');
    } catch (e) {
      showError(_.get(e, 'message', 'Could not resend code'));
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { email, otp, loading } = this.state;
    return (
      <div className="auth-page">
        <div className="auth-card">
          <h1 className="auth-title">Verify email</h1>
          <p className="auth-sub">Enter the 6-digit code we sent to your email.</p>
          <form onSubmit={this.handleVerify}>
            <label htmlFor="ve-email">Email</label>
            <input
              id="ve-email"
              type="email"
              value={email}
              onChange={this.handleChange('email')}
              required
            />
            <label htmlFor="ve-otp">OTP code</label>
            <input
              id="ve-otp"
              value={otp}
              onChange={this.handleChange('otp')}
              required
              maxLength={6}
            />
            <button type="submit" className="auth-cta" disabled={loading}>
              Verify & continue
            </button>
          </form>
          <button
            type="button"
            className="auth-link-btn"
            onClick={this.handleResend}
            disabled={loading}
          >
            Resend code
          </button>
        </div>
      </div>
    );
  }
}

export default VerifyEmail;
